import { Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import Button from 'ihp-components/components/v2/Button';
import { ReactComponent as HospitalIcon } from 'images/data-sync/hospital.svg';
import { ArrowBackwardIcon } from 'pages/Activities/List/styles';
import { useNavigate } from 'react-router-dom';

export const EmptyProvider = ({ loader, hasErrors }) => {
  const navigate = useNavigate();

  const title = hasErrors
    ? 'We are experiencing some difficulties'
    : 'We are still processing your data';
  const subtitle = hasErrors
    ? 'Please retry again later'
    : 'Please wait for the data to be loaded. It can take up to 24 hours.';
  return (
    <Stack
      justifyContent='center'
      alignItems='center'
      spacing='20px'
      height='65vh'
      sx={{ bgcolor: (theme) => theme.palette.primary.gray20 }}
    >
      <HospitalIcon height={60} width={60} sx={{ alignContent: 'center' }} />
      <Box
        sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}
      >
        <Stack justifyContent='center' spacing='5px'>
          <Typography variant='h5' color='primary.gray75' align='center'>
            {title}
          </Typography>
          <Typography variant='pl5' color='primary.gray50' align='center'>
            {subtitle}
          </Typography>
          {hasErrors && (
            <Box sx={{ paddingTop: '30px', display: 'flex' }}>
              <Button
                startIcon={<ArrowBackwardIcon width={14} height={14} />}
                type='submit'
                sx={{ width: '150px', margin: 'auto' }}
                onClick={() => navigate('/profile/my-providers')}
              >
                Go back
              </Button>
            </Box>
          )}
        </Stack>
        {loader}
      </Box>
    </Stack>
  );
};
